import React from 'react'
import Team7 from '../resources/partner/team7.png'
import Gießerei from '../resources/partner/gießerei.png'
import KOBL from '../resources/partner/kobl.webp'
import Guat from '../resources/partner/guat.jpg'
import Riadarei from '../resources/partner/riadarei.jpg'
import Hochleckenhaus from '../resources/partner/hochleckenhaus2.jpeg'
//import InnviertlerVersailles from '../resources/partner/innviertlerversailes.png'
import EnergieAlm from '../resources/partner/energiealm.png'
import Grünseis from '../resources/partner/grünseis.jpeg'
import RehaAmbulant from '../resources/partner/reha-ambulant.png'
import rindenkind from '../resources/partner/rindenkind.png'
import Bauboeck from '../resources/partner/bauboeck.png'
import Kuhbik from '../resources/partner/kuhbik.png'
import Inns_gwoelb from '../resources/partner/inns_gwoelb.png'
import Werk7 from '../resources/partner/werk7_restaurant.webp'
import './partners.css'

const partners = [
  { name: 'Gießerei', logo: Gießerei, link: 'https://www.giesserei-ried.at/' },
  { name: 'EnergieAlm', logo: EnergieAlm, link: 'https://www.energiealm.at/' },
  // {
  //   name: 'Innviertler Versailles',
  //   logo: InnviertlerVersailles,
  //   link: 'https://www.innviertler-versailles.at/'
  // },
  { name: 'KOBL - Bio in Ried', logo: KOBL, link: 'https://www.kobl.at/' },
  { name: 'Guad', logo: Guat, link: 'https://www.guat-taiskirchen.at/' },
  { name: 'Riadarei', logo: Riadarei, link: 'https://www.riadarei.at/' },
  {
    name: 'Hochleckenhaus',
    logo: Hochleckenhaus,
    link: 'https://hochleckenhaus.at/'
  },
  { name: 'Grünseis', logo: Grünseis, link: 'https://www.gruenseis.at/' },
  {
    name: 'Reha-Ambulant',
    logo: RehaAmbulant,
    link: 'https://www.reha-ambulant.at/'
  },
  { name: 'Team7', logo: Team7, link: 'https://www.team7.at/' },
  { name: 'Rindenkind', logo: rindenkind, link: 'http://www.rindenkind.at/' },
  { name: 'Bauböck', logo: Bauboeck, link: 'https://www.bauboeck.info/' },
  { name: 'Kuhbik', logo: Kuhbik, link: 'https://kuhbik.at/' },
  { name: 'Inns_gwoelb', logo: Inns_gwoelb, link: 'https://inns-gwoelb.de/' },
  { name: 'Werk7', logo: Werk7, link: 'https://www.restaurant-werk7.at/' }

]

// Alphabetisch sortieren
const sortedPartners = [...partners].sort((a, b) =>
  a.name.localeCompare(b.name, 'de', { sensitivity: 'base' })
)

const Partner = () => {
  return (
    <div className='partners-container'>
      <h1 className='partners-title'>Unsere Partner</h1>
      <div className='partners-grid'>
        {sortedPartners.map((partner, index) => (
          <div
            key={index}
            className='partner-logo-div'
            onClick={() => window.open(partner.link, '_blank')}
            style={{ cursor: 'pointer' }}
            title='Zur Website'
          >
            <img
              className='partner-logo'
              src={partner.logo}
              alt={partner.name}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default Partner
